import { useMemo } from 'react';
import { SIDE_NAV_TEST_IDS } from '../../constants';
import SideNavSection from '../SideNavSection/SideNavSection';
import { buildDealSections } from './buildDealSections';

interface IDealSideNav {
    dealId: string;
    isCollapsed: boolean;
    onCollapsedParentClick: (parentId: string) => void;
    openParentIds: Set<string>;
    onOpenParent: (parentId: string) => void;
    onToggleParent: (parentId: string) => void;
}

const DealSideNav = ({
    dealId,
    isCollapsed,
    onCollapsedParentClick,
    openParentIds,
    onOpenParent,
    onToggleParent,
}: IDealSideNav) => {
    const sections = useMemo(() => buildDealSections(dealId), [dealId]);

    return (
        <div data-testid={SIDE_NAV_TEST_IDS.DEAL_HOME}>
            {sections.map(section => (
                <SideNavSection
                    key={section.id}
                    section={section}
                    isCollapsed={isCollapsed}
                    onCollapsedParentClick={onCollapsedParentClick}
                    openParentIds={openParentIds}
                    onOpenParent={onOpenParent}
                    onToggleParent={onToggleParent}
                />
            ))}
        </div>
    );
};

export default DealSideNav;
